exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error[data-v-5076c706] {\n  border: 1px solid red;\n}", ""]);

// exports
